import McSlider from './McSlider';

export default McSlider;
